module.exports = __webpack_public_path__ + "static/media/drag.c24d8dff.svg";